import {useLayoutEffect, useRef} from 'react'
import {useSettingsDefaultPage} from 'hooks/useSettings'
import {settingsMobileStore} from 'features/Settings/mobile/settingsMobileStore'

/**
 * Arriving in Settings on its default page (the navigation's Settings link)
 * shows the home list; a deep link to any other page opens that page, and
 * later route changes inside Settings always show the page.
 */
export function useSettingsMobileEntry(pathname: string): void {
  const defaultPage = useSettingsDefaultPage()
  const lastPathname = useRef<string | null>(null)

  useLayoutEffect(() => {
    if (lastPathname.current === null) {
      settingsMobileStore.setPageOpen(pathname !== defaultPage)
    } else if (lastPathname.current !== pathname) {
      settingsMobileStore.setPageOpen(true)
    }
    lastPathname.current = pathname
    // The default page only decides the first arrival.
  }, [pathname])
}
